export default "__VITE_ASSET__Cw3c6yM2__"